import { releaseNotesActions } from "./actions";
import { releaseNotesGetters } from "./getters";
import { releaseNotesMutations } from "@tt-app/store/releaseNotes/mutations";
import { releaseNotesState } from "@tt-app/store/releaseNotes/state";

const releaseNotesModule = {
  namespaced: true,
  actions: releaseNotesActions,
  getters: releaseNotesGetters,
  mutations: releaseNotesMutations,
  state: releaseNotesState
};

export { releaseNotesModule };
